import { object, boolean } from '@gogame/schemas';

import {
  CHART_SETTINGS_TREND,
  CHART_SETTINGS_SERIES_SUM,
} from 'scenes/KPI/constants';

export const chartSettingsSchema = object(
  {
    [CHART_SETTINGS_TREND]: boolean().default(false),
    [CHART_SETTINGS_SERIES_SUM]: boolean().default(false),
  },
  'chartSettings'
);
